module.exports = __webpack_public_path__ + "static/media/image 51.436fcfdb.svg";